import { render, staticRenderFns } from "./EventTime.vue?vue&type=template&id=f0d6d7f8&"
import script from "./EventTime.vue?vue&type=script&lang=ts&"
export * from "./EventTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0d6d7f8')) {
      api.createRecord('f0d6d7f8', component.options)
    } else {
      api.reload('f0d6d7f8', component.options)
    }
    module.hot.accept("./EventTime.vue?vue&type=template&id=f0d6d7f8&", function () {
      api.rerender('f0d6d7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/tickets/EventTime.vue"
export default component.exports